import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_ctx.$store.state.tagsPages.length)
    ? (_openBlock(), _createBlock(_component_el_tabs, {
        key: 0,
        type: "card",
        "model-value": _ctx.$route.name,
        onTabClick: _ctx.onTabClick
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.tagsPages, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: index,
              label: item.title,
              name: item.name
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['pages', 'point', _ctx.$route.name === item.name ? 'active' : '']),
                  onClick: _withModifiers(($event: any) => (_ctx.goTabPage(item)), ["stop"])
                }, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  _createElementVNode("i", {
                    class: "el-icon el-icon-circle-close",
                    onClick: _withModifiers(($event: any) => (_ctx.delTab(item.path, item.name)), ["stop"])
                  }, null, 8, _hoisted_2)
                ], 10, _hoisted_1)
              ]),
              _: 2
            }, 1032, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model-value", "onTabClick"]))
    : _createCommentVNode("", true)
}